import React, { useEffect, useState } from "react"

import * as TrinityAPI from "@/requests/TrinityAPI"

import { IFloatingRateDto } from "@/types/company/IFloatingRateDto"
import { IModalMessage } from "@/types/error/IModalMessage"
import { ModalPopUp } from "@/components/common/element/ModalPopUp"
import { spacedNum } from "@/components/common/CommonHelper"

type Props = {
  rateType: string
  userId?: number
}

export const ClientRates: React.FC<Props> = ({ rateType, userId }) => {
  const [rates, setRates] = useState<IFloatingRateDto[]>([])
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  useEffect(() => {
    if (userId) {
      getClientRates()
    } else {
      getRates()
    }
  }, [userId])

  const getRates = () => {
    TrinityAPI.getBaseRate(rateType, response => {
      if (response.status === 200) {
        setRates(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения данных с сервера: " + response.data.message })
      }
    })
  }

  const getClientRates = () => {
    TrinityAPI.getClientFloatingRates(
      rateType,
      response => {
        if (response.status === 200) {
          if (!response.data || !response.data?.length) {
            getRates()

            return
          }

          setRates(response.data)
        } else {
          setModalMessage({ title: "Ошибка!", text: "Ошибка получения данных с сервера: " + response.data.message })
        }
      },
      userId
    )
  }

  const getHeading = () => {
    switch (rateType) {
      case "AMOUNT":
        return "От суммы платежа"
      case "VOLUME":
        return "По сумме инвойса по объему месячному"
      default:
        return "От месячного оборота"
    }
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <div className="form-block-popup width-full">
        <h4 className="heading-chapter">{getHeading()}</h4>
        {rates.map((r, index) => (
          <div className="flex-row-24" key={index}>
            <div className="condition">
              {`${r.operator} ${spacedNum(r.amount || 0)} USD = ${r.rate}% ${
                r.onTopAmount ? `+ ${r.onTopAmount} USD` : ""
              }`}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
